import { c as _c } from "react/compiler-runtime";
import { Controller, type ControllerProps, type FieldPath, type FieldValues } from 'react-hook-form';
import { RadioGroup, type RadioGroupProps } from '../radio-group';
type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;
type RadioGroupRhfProps<T extends string, TValues extends FieldValues, TName extends FieldPath<TValues>> = DistributiveOmit<RadioGroupProps<T>, 'onChange' | 'selected'> & Omit<ControllerProps<TValues, TName>, 'render'>;
function RadioGroupRhf(props) {
  const $ = _c(12);
  let control;
  let name;
  let restProps;
  let rules;
  if ($[0] !== props) {
    ({
      control,
      name,
      rules,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = control;
    $[2] = name;
    $[3] = restProps;
    $[4] = rules;
  } else {
    control = $[1];
    name = $[2];
    restProps = $[3];
    rules = $[4];
  }
  let t0;
  if ($[5] !== restProps) {
    t0 = t1 => {
      const {
        field
      } = t1;
      return <RadioGroup {...restProps} selected={field.value} onChange={field.onChange} />;
    };
    $[5] = restProps;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== control || $[8] !== name || $[9] !== rules || $[10] !== t0) {
    t1 = <Controller control={control} name={name} rules={rules} render={t0} />;
    $[7] = control;
    $[8] = name;
    $[9] = rules;
    $[10] = t0;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}
export { RadioGroupRhf };
export type { RadioGroupRhfProps };